import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { UserBackendService } from "@app/user/user-core/services/user-backend.service";
import { FileBase64DtoUI } from "@app/user/user-core/api/export";
import { DocumentType } from "@helper/abstraction/documents";

@Component({
  selector: "app-iframe",
  templateUrl: "./iframe.component.html",
  styleUrls: ["./iframe.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class IframeComponent implements OnDestroy, OnChanges {
  @Input() public bodyParams?: { id: number, documentType: DocumentType };
  @Input() public fileName?: string;
  @Input() public statusName?: string;
  @Input() public content?: string;
  public url?: SafeResourceUrl | Blob;
  public mimeType?: string;
  public iframeType?: "TXT" | "PDF";
  
  private unsubscribe$$: Subject<void> = new Subject<void>();

  constructor(
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private userBackendService: UserBackendService,
  ) { }

  public ngOnChanges(): void {
    if (this.content) {
      this.mimeType = this.checkMimeType(this.fileName!);
      const byteArray = Uint8Array.from(atob(this.content), c => c.charCodeAt(0));
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      this.url = blob;
      this.cdr.detectChanges();
    } else if (this.fileName) {
      this.getUrl();
    }
  }

  public ngOnDestroy(): void {
      this.unsubscribe$$.next();
      this.unsubscribe$$.complete();
  }

  private getUrl(): void {
    this.mimeType = this.checkMimeType(this.fileName!);
    if (!this.mimeType || !this.bodyParams) {
      return;
    }
    this.userBackendService.export.getFileBase64.get$(this.bodyParams!)
      .pipe(takeUntil(this.unsubscribe$$))
      .subscribe((contentFile: FileBase64DtoUI) => {
        switch (this.iframeType) {
          case "PDF": {
            const byteArray = Uint8Array.from(atob(contentFile.content), c => c.charCodeAt(0));
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            this.url = blob;
          }
            break;
          case "TXT": {
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(`data:${this.mimeType};base64,${contentFile.content}`);
          }
            break;
          default:
            break;
        }
        this.cdr.detectChanges();
      });
  }

  private checkMimeType(fileName: string): string | undefined {
    const name = fileName.split(".").reverse()[0].toLocaleLowerCase();

    let mimeType: string | undefined;
    switch (name) {
      case "pdf":
        mimeType = "application/pdf";
        this.iframeType = "PDF";
        break;
      case "txt":
        mimeType = "text/plain;charset=utf-8";
        this.iframeType = "TXT";
        break;
      default:
        mimeType = undefined;
        break;
    }
    return mimeType;
  }
}
